<template>
  <div id="app">
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div>
    <router-view /> -->

    <div class="drawer">
      <div class="drawer__logo">
        <img
          src="https://www.jway.com/wp-content/uploads/2015/12/Logo-JWay.svg"
          alt="JWay Group Inc."
          @click="$router.push('/getting-started')"
        />
      </div>
      <div class="drawer__links">
        <ul>
          <li class="header">
            General
          </li>
          <li>
            <i class="material-icons">domain</i>
            <router-link to="/parts">Parts</router-link>
          </li>
          <li>
            <i class="material-icons">domain</i>
            <router-link to="/products">Products</router-link>
          </li>

          <li>
            <i class="material-icons">domain</i>
            <router-link to="/participant">Register</router-link>
          </li>

          <div v-if="accounts">
            <li class="header">
              Personal
            </li>
            <li>
              <i class="material-icons">domain</i>
              <router-link to="/contract">Smart Contract</router-link>
            </li>
            <li v-b-toggle.collapse-part>
              <i class="material-icons">domain</i>
              Part
            </li>

            <b-collapse id="collapse-part" class="mt-2">
              <li>
                <router-link
                  :to="{ name: 'SpecificParts', params: { id: accounts } }"
                  >View Parts</router-link
                >
              </li>
              <li>
                <router-link
                  :to="{ name: 'Parts/register', params: { id: accounts } }"
                  >Register Part</router-link
                >
              </li>
            </b-collapse>

            <li v-b-toggle.collapse-product>
              <i class="material-icons">domain</i>
              Product
            </li>
            <b-collapse id="collapse-product" class="mt-2">
              <li>
                <router-link
                  :to="{ name: 'SpecificProducts', params: { id: accounts } }"
                  >View Products</router-link
                >
              </li>
              <li>
                <router-link to="/products/register"
                  >Register Product</router-link
                >
              </li></b-collapse
            >
          </div>
        </ul>
      </div>
    </div>
    <div class="content">
      <b-container><router-view /></b-container>
    </div>
    <PrivateKeyModal />
    <NotificationModal />
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from 'vuex'
import PrivateKeyModal from '@/components/modal/PrivateKey.vue'
import NotificationModal from '@/components/modal/Notification.vue'

export default {
  components: {
    PrivateKeyModal,
    NotificationModal
  },
  computed: {
    ...mapState(['contracts', 'accounts'])
  },
  async mounted() {}
}
</script>

<style lang="scss">
ul {
  list-style: none;
  padding: 0;
}

li {
  padding: 0 0 0 25px;
  cursor: pointer;
}

#app {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  display: flex;
}

.drawer {
  width: 250px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  border-right: 1px solid rgba(0, 0, 0, 0.12);
  position: fixed;
  // background-color: rgb(21, 32, 43);
}

.drawer__logo {
  width: 100%;
  height: calc(100vh * 0.15);
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
}

.drawer__logo img {
  width: 200px;
  cursor: pointer;
}

.drawer__links {
  width: 100%;
  height: calc(100vh * 0.85);
  // color: white;
}

.drawer__links ul li {
  display: flex;
  align-items: center;
  height: 2.5em;
}

.drawer__links ul li:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.drawer__links ul li a {
  text-decoration: none;
  color: black;
  width: 100%;
}

.drawer__links ul li.header {
  margin: 10px 0;
  font-weight: 700;
}

.drawer__links ul li.header:hover {
  background-color: white;
  cursor: default;
}

.drawer__links ul li i {
  margin-right: 0.5em;
}

.content {
  width: calc(100vw - 250px);
  min-height: 100vh;
  // Experimental
  margin-left: 250px;
  // display: flex;
  // align-items: center;
}

#collapse-part li a,
#collapse-product li a {
  padding: 0 0 0 35px;
}

.container {
  padding: 50px;
}
</style>
